export default __webpack_public_path__ + "static/media/PrexelLogo.55fcebde.png";